// import {useStripe, useElements, PaymentElement} from '@stripe/react-stripe-js';

// const CheckoutForm = () => {
//   const stripe = useStripe();
//   const elements = useElements();

//   const handleSubmit = async (event) => {
//     // We don't want to let default form submission happen here,
//     // which would refresh the page.
//     event.preventDefault();

//     if (!stripe || !elements) {
//       // Stripe.js hasn't yet loaded.
//       // Make sure to disable form submission until Stripe.js has loaded.
//       return;
//     }

//     const result = await stripe.confirmPayment({
//       //`Elements` instance that was used to create the Payment Element
//       elements,
//       confirmParams: {
//         return_url: "https://stripe.com/docs/stripe-js/react",
//       },
//     });

//     if (result.error) {
//       // Show error to your customer (for example, payment details incomplete)
//       console.log(result.error.message);
//     } else {
//       // Your customer will be redirected to your `return_url`. For some payment
//       // methods like iDEAL, your customer will be redirected to an intermediate
//       // site first to authorize the payment, then redirected to the `return_url`.
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit}>
//       <PaymentElement />
//       <button disabled={!stripe}>Submit</button>
//     </form>
//   )
// };

// export default CheckoutForm;





import React, { useState, useEffect } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useNavigate } from "react-router-dom";
export default function CheckoutForm(props) {
  // 1️⃣ Setup state to track client secret, errors and checkout status
  const [succeeded, setSucceeded] = useState(false);
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [clientSecret, setClientSecret] = useState(props?.clientSecretss);
  // 2️⃣ Store reference to Stripe
  const stripe = useStripe();
  const navigate = useNavigate();
  const elements = useElements();
  // useEffect(() => {
  //   let token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNjk2ODU0MTMwLCJpYXQiOjE2ODkwNzgxMzAsImp0aSI6ImEzNDAxYjgzMThiMTQ4ZGE4MzE2MzM3MWZjNzUzZGFiIiwidXNlcl9pZCI6Nywicm9sZSI6InJlY3J1aXRlciJ9.DfuQWiLqN6tGtOxNBWkPDqaKLb5lUyy3-_AATRVjXqg"
  //   // 3️⃣ Create PaymentIntent and fetch client secret as soon as the page loads
  //   window.fetch("https://api.catzapp.com/manage_plan_txn/", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: "Bearer " + token,
  //     },
  //     body: JSON.stringify({
  //         serviceId: 2,
  //         subscription_id: 2,
  //         txnAmount: 20 * 100,
  //         gateWayName: "card",
  //         paymentMode: 1,
  //         user_type: "RECRUITER"
  //       }),
  //   }).then((res) => { 
  //     return res.json();
  //   }).then((data) => {
  //     console.log("sdeee",data.data.payment_intent.client_secret);
  //     setClientSecret(data.data.payment_intent.client_secret);
  //   });
  // }, []);
  const handleChange = async (event) => {
    // 4️⃣ Listen for changes in the CardElement and display any errors as the customer types their card details
    setDisabled(event.empty);
    setError(event.error ? event.error.message : "");
  };
  const handleSubmit = async (ev) => {
    console.log("sssssssawwwwww",clientSecret);
    ev.preventDefault();
    setProcessing(true);
   // 5️⃣ Confirm Card Payment.
  
    const payload = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: elements.getElement(CardElement),
      },
    });
   
    if (payload.error) {
      setError(`Payment failed ${payload.error.message}`);
      setProcessing(false);
    } else {
      setError(null);
      setProcessing(false);
      setSucceeded(true);
      props.checkVal()
      navigate("/home")
    }
  }
// 6️⃣ Construct UI.
return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <CardElement 
        id="card-element"
        // {/* Specify styles here */}
        options={{}} 
        onChange={handleChange}
      />
      <div className="text-center">
      <button disabled={processing || disabled || succeeded} id="submit" className="payment-btn">
        <span id="button-text" >
          {processing ? <div className="spinner" id="spinner"></div> : "Pay"}
        </span>
      </button>
      </div>
      {/* Show any error that happens when processing the payment */}
      {error && (
        <div className="card-error" role="alert">{error}</div>
      )}
      {/* Show a success message upon completion */}
      {/* <p className={succeeded ? "result-message" : "result-message hidden"}>Payment succeeded!</p> */}
    </form>
  );
}